module.exports = __webpack_public_path__ + "img/logo_light.3aa477d7.svg";